import CorsProxy from '@ibiquity/dashboard.cors-proxy';
import { isHls } from './audioFormats';

const {
  VUE_APP_STREAMING_PROXY_URL: PROXY_URL = '',
  VUE_APP_PROXY_SECRET_KEY: SECRET_KEY = '',
} = process.env;

const proxy = new CorsProxy({ baseUrl: PROXY_URL, secretKey: SECRET_KEY });
const hlsQuery = '&type=.m3u8';

export function formatUrl(url) {
  const formatted = proxy.format(url);
  if (formatted !== url && isHls(url)) return `${formatted}${hlsQuery}`;
  return formatted;
}

export function parseUrl(url) {
  return proxy.parse(url.replace(hlsQuery, ''));
}

export default {
  formatUrl,
  parseUrl,
};
